export const initialState = {
    is_loading: true,
    total_customers: 0,
    total_pages: 0,
    page_number: 1,
    list: [],
    serach_text: '',
    sort_key: '',
    sort_direction: ''
}